import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { deleteMedia, deleteMultipleMedia } from "../../api/apiMedias";
import parseError from "../../utils/parseError";

const useDeleteMedia = () => {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: deleteSingleMedia,
        isPending: isDeletingSingle,
    } = useMutation({
        mutationFn: deleteMedia,
        onSuccess: (response) => {
            enqueueSnackbar(response.message || "Media deleted successfully", { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["media"] });
        },
        onError: (error) => {
            const message = parseError(error);
            enqueueSnackbar(message || "Failed to delete media", { variant: "error" });
        },
    });

    const {
        mutate: deleteMultipleMediaMutate,
        isPending: isDeletingMultiple,
    } = useMutation({
        mutationFn: deleteMultipleMedia,
        onSuccess: (response) => {
            enqueueSnackbar(response.message || "Media files deleted successfully", { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["media"] });
        },
        onError: (error) => {
            const message = parseError(error);
            enqueueSnackbar(message || "Failed to delete media files", { variant: "error" });
        },
    });

    return {
        deleteSingleMedia,
        deleteMultipleMediaMutate,
        isDeleting: isDeletingSingle || isDeletingMultiple,
        isDeletingSingle,
        isDeletingMultiple,
    };
};

export default useDeleteMedia;
